import React  from 'react';


function Backdrop(props)
{
    return( <div  className='backdrop' aria-hidden="true" onClick={props.onClick} onKeyDown={() => {}}/>);
}
export default Backdrop;